import styled, {css} from "styled-components";
import { CTAPrimaryButton } from '../../../../app/js/components/loggedout/shared-styles/CTAPrimaryButton';
import { ContainerWrapper, Heading1, CTAButtonWrapper, OfferText } from "../../common/styled-components/styled-components";
import { white, whiteLilac, royal, orange, lightPurple, deepCoveDark, black, indigo, darkOrange } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import { breakpoints, device } from '../../../../app/js/utils/responsive_utilities';
import { fontQuicksand } from '../../common/mixins/mixin'; 

export const Wrapper = styled(ContainerWrapper)``;

export const ContentTitle = styled(Heading1)`
  @media (min-width: ${breakpoints.lg}px) {
    ${fontQuicksand(3.6, 2.8, 7)}
    margin-bottom: 3rem;
  }
`;

export const ContentWrapper = styled.div``;

export const StoriesList = styled.ul`
  ${fontQuicksand(1.2, 1.6, 7)}
  list-style: none;
  color: ${whiteLilac};
  background: ${royal};
  border-radius: 0.8rem;
  width: 90%;
  margin : auto;
  box-sizing: border-box;
  padding: 1rem;
  
  & > li:before{
    content: '✓';
    color: ${orange};
    padding-right: 1rem;
  }

  & > li{
    padding: 0.8rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 53.43%;
    padding: 2rem 0;
    & > li {
      padding: 0 25.7%;
      ${fontQuicksand(1.6, 1.6, 7)}
      &:not(:last-child) {
        margin-bottom: 1.2rem;
      }
    }
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: space-around;    
  margin-top: 3.52rem;
  margin-bottom: 3rem;
  ${props=>props.widthFull ? css`width: 100%` : null};
  img{
    width: 8.9rem;
    height: 11.8rem;   
  }
  @media (min-width: ${breakpoints.md}px) {
    max-width: ${props=>props.widthFull ? 77 : 50}rem;
    margin: 4.5rem auto ${props=>props.widthFull ? 10 : 6}rem;

    img{
      width: ${props=>props.widthFull ? '19rem': '12rem'};
      height: ${props=>props.widthFull ? '19rem': '16rem'};
    }
  }
  @media (min-width: ${breakpoints.lg}px) {
    max-width: ${props=>props.widthFull ? 77 : 50}rem;
    margin: 4.5rem auto ${props=>props.widthFull ? 10 : 6}rem;

    img{
      width: ${props=>props.widthFull ? '19rem': '12rem'};
      height: ${props=>props.widthFull ? '19rem': '16rem'};
    }
  }
`;

export const IllustrationImageWrapper = styled.div`
  width : 100%;
  position: relative;
  bottom: -5.5rem;
  left: 0;
  img{
    width: 100%;
    height:100%;
  }
  ${props => props.hideOn === 'mobile' ? 'display: none;' : 'display: block;'}

  @media (min-width: ${breakpoints.lg}px) {
    ${props => props.hideOn === 'desktop' ? 'display: none;' : 'display: block;'}
    height: 35.5rem;
    bottom: -10rem;
    margin-top: -7rem;
  }

  @media ${device.PhoneLandscape}{
    height: 25rem;
    bottom: -7rem;
  }

  @media ${device.Tablet}{
    bottom: -8.7rem;
  }

  @media ${device.TabletLandscape}{
    height: 30rem;
  }

`;

export const SuccessOfferText = styled(OfferText)`
  @media (min-width: ${breakpoints.lg}px) {
    ${fontQuicksand(1.6, 2, 7)}
  }
`;

export const ButtonWrapper = styled(CTAButtonWrapper)``;

export const CTAOfferButton = styled(CTAPrimaryButton)``;

